// data/workData.js

import Apple2026Logo from "../images/work/Apple2026_Logo.png";
import Apple2025Logo from "../images/work/Apple2025_Logo.png";
import VerizonLogo from "../images/work/Verizon_Logo.png";
import Apple2024Logo from "../images/work/Apple2024_Logo.png";
import EventManagementLogo from "../images/work/EventManagement_Logo.jpg";

export const workExperiences = {
  apple2026: {
    company: "Apple",
    role: "Tools and Automation Engineer, AirPlay QE",
    location: "San Diego, CA",
    startDate: "Jun 2026",
    logoRef: Apple2026Logo,
    logoAlt: "Black HomePod Mini on a light blue gradient background.",
    description:
      "Developing automated solutions and tools to support quality of AirPlay-enabled devices.",
  },

  apple2025: {
    company: "Apple",
    role: "AirPlay Software Development Intern",
    location: "Cupertino, CA",
    startDate: "Jun 2025",
    endDate: "Aug 2025",
    logoRef: Apple2025Logo,
    logoAlt: "Liquid glass-themed Apple logo",
    description:
      "Designed and implemented a transport level pooling infrastructure for the core AirPlay systems, achieving 3x faster connection establishment.",
  },

  verizon: {
    company: "Verizon",
    role: "5G Engineering Co-op, Tools and Automation",
    location: "Columbus, OH",
    startDate: "Jan 2025",
    endDate: "Jun 2025",
    logoRef: VerizonLogo,
    logoAlt: "Verizon logo",
    description:
      "Developed real-time network monitoring tools and automated dashboards that reduced outage detection time while supporting 5G NR and 4G LTE operations.",
  },

  apple2024: {
    company: "Apple",
    role: "AirPlay Quality Engineering Intern",
    location: "San Diego, CA",
    startDate: "Jan 2024",
    endDate: "Jun 2024",
    logoRef: Apple2024Logo,
    logoAlt: "iOS 18-themed Apple logo",
    description:
      "Designed and implemented a Python tool for automated device preparation for testing. Contributed to automated test coverage for CarPlay and tvOS platforms.",
  },

  eventmanagement: {
    company: "Northeastern University",
    role: "Lighting Engineer, Audio Technician",
    location: "Boston, MA",
    startDate: "Sep 2022",
    endDate: "Apr 2026",
    logoRef: EventManagementLogo,
    logoAlt: "Dancers on stage",
    description:
      "Programmed automated lighting systems and managed live AV production for 200+ campus events using ETC Eos lighting consoles, Yamaha audio boards, and QLab software.",
  },
};
